import { ListItem } from '@lmnop/web-core';

export class UninstallModel {
    public reasons: ListItem[];
    public otherReason: string;
}
